import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MedicalFeePaymentSearchComponent } from './medical-fee-payment-search.component';
import { MedicalFeePaymentFilterComponent } from '../medical-fee-payment-filter/medical-fee-payment-filter.component';
import { SharedModule } from '../../shared.module';
import { SharedMaterialModule } from '../../shared-material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material';

@NgModule({
  declarations: [
    MedicalFeePaymentSearchComponent,
    MedicalFeePaymentFilterComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedMaterialModule,
    ReactiveFormsModule,
    MatTooltipModule
  ]
})
export class MedicalFeePaymentSearchModule { }
